// Display formatters for the dispatch UI.

export function fmtMiles(miles: number | null): string {
  return miles == null ? '—' : `${miles.toFixed(1)} mi`
}

/** "IN_PROGRESS_ALLOCATED" → "IN PROGRESS ALLOCATED". */
export function fmtExecutionStatus(status: string): string {
  return status.replaceAll('_', ' ')
}

/** Badge colour classes for a job's execution status. */
export function executionStatusClass(status: string): string {
  const s = status.toUpperCase()
  if (s.includes('DONE') || s.includes('COMPLETED'))
    return 'bg-emerald-100 text-emerald-700 hover:bg-emerald-100'
  if (s.includes('IN_PROGRESS')) return 'bg-blue-100 text-blue-700 hover:bg-blue-100'
  return 'bg-slate-100 text-slate-600 hover:bg-slate-100'
}

const CHASE2BASE_APP = 'http://chase2base.co.uk/app'

/** Deep link to a partner's contacts tab in Chase2Base. */
export function partnerContactsUrl(partnerId: string): string {
  return `${CHASE2BASE_APP}/open?screen=service-partner-management&item=egis$ServicePartner-${partnerId}&params=tab:contactsTab`
}

/** Deep link to a job's view screen in Chase2Base. */
export function jobViewUrl(jobId: string): string {
  return `${CHASE2BASE_APP}/open?screen=egis$Job.viewJob&item=egis$Job-${jobId}-job.jobView`
}

export function fmtMins(min: number): string {
  const r = Math.round(min)
  if (r < 60) return `${r} min`
  const h = Math.floor(r / 60)
  const m = r % 60
  return m ? `${h}h ${m}m` : `${h}h`
}

export function fmtDuration(seconds: number): string {
  return fmtMins(seconds / 60)
}

export function lastSeenLabel(iso: string | null): string | null {
  if (!iso) return null
  const t = Date.parse(iso)
  if (Number.isNaN(t)) return null
  const min = Math.max(0, Math.round((Date.now() - t) / 60000))
  if (min < 1) return 'Just now'
  if (min < 60) return `${min}m ago`
  const h = Math.floor(min / 60)
  if (h < 24) return `${h}h ago`
  return `${Math.floor(h / 24)}d ago`
}

/** "dd/mm/yyyy HH:mm" (no comma); echoes the raw value if unparseable. */
export function fmtDateTime(iso: string | null): string | null {
  if (!iso) return null
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return iso
  return d
    .toLocaleString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    })
    .replace(',', '')
}
